<script>
    import AuthorizedLayout from "../_templates/AuthorizedLayout.svelte";
    import MetaTags from "../_templates/MetaTags.svelte";

    let urlParams = new URLSearchParams(window.location.hash.substring(1));
    let viewOnly = urlParams.get("viewOnly") ?? false;
</script>

<MetaTags></MetaTags>

{#if viewOnly}
    <slot></slot>
{:else}
    <AuthorizedLayout>
        <slot></slot>
    </AuthorizedLayout>
{/if}
